var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-130 -130 260 260",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 125,
    stroke: "#fff",
    strokeWidth: "8px",
    fill: "#282828"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M -69.486621 0 A 132.171408 132.171408 0 0 1 -21.472547 66.085704 A 132.171408 132.171408 0 0 1 56.215857 40.843211 A 132.171408 132.171408 0 0 1 56.215857 -40.843211 A 132.171408 132.171408 0 0 1 -21.472547 -66.085704 A 132.171408 132.171408 0 0 1 -69.486621 0 z",
    stroke: "none",
    strokeWidth: "8px",
    fill: "#9ca1ef"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M -122.867994 -22.988171 A 132.171408 132.171408 0 0 1 -16.105248 123.958142",
    stroke: "#fff",
    strokeWidth: "8px",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M -59.831348 109.750671 A 132.171408 132.171408 0 0 1 112.914403 53.622174",
    stroke: "#fff",
    strokeWidth: "8px",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 85.890187 90.817816 A 132.171408 132.171408 0 0 1 85.890187 -90.817816",
    stroke: "#fff",
    strokeWidth: "8px",
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 112.914403 -53.622174 A 132.171408 132.171408 0 0 1 -59.831348 -109.750671",
    stroke: "#fff",
    strokeWidth: "8px",
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M -16.105248 -123.958142 A 132.171408 132.171408 0 0 1 -122.867994 22.988171",
    stroke: "#fff",
    strokeWidth: "8px",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8a5a20473cab91b6ef49285c3d6c36c9.svg";
export { ForwardRef as ReactComponent };